import { createClient, SupabaseClient  } from '@supabase/supabase-js';

export default class ApiHandler {

    static readonly SUPABASE_URL: string = 'https://ibuuvlajdscsnnrcmthj.supabase.co';
    static readonly SUPABASE_ANON_KEY: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlidXV2bGFqZHNjc25ucmNtdGhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDA4NDkzMzQsImV4cCI6MjAxNjQyNTMzNH0.ag4hLOJqglzcp4h-lNgH0WU0way9S2Ue5m9AOYYs-h0';

    private static supabase: SupabaseClient = createClient(this.SUPABASE_URL, this.SUPABASE_ANON_KEY);


    public static async getTopGlobalScores(): Promise<any> {
        const { data, error } = await this.supabase.rpc('get_top_global_scores');
        if (error) {
            throw new Error(`Error getting scores to user: ${error.message}`);
        }

        return data;
    }

    public static async getTopLevelScores(): Promise<any> {
        const { data, error } = await this.supabase.rpc('get_top_level_scores');
        if (error) {
            throw new Error(`Error getting scores to user: ${error.message}`);
        }

        const groupedByLevel = data.reduce((acc: any, curr: any) => {
            if (!acc[curr.level]) {
                acc[curr.level] = [];
            }
        
            acc[curr.level].push({
                user_id: curr.user_id,
                name: curr.name,
                score: curr.score,
            });
        
            return acc;
        }, {} as Record<number, Array<{ user_id: number, name: string, score: number }>>);

        return groupedByLevel;
    }

    public static async saveUser(userData: any): Promise<any> {
        const { data, error } = await this.supabase
            .from('users')
            .upsert(userData)
            .select();

        if (error) {
            throw new Error(`Error saving user: ${error.message}`);
        }

        return data[0];
    }

    public static async getUserByFingerprint(fingerprint: string): Promise<any> {
        const { data, error, status } = await this.supabase
            .from('users')
            .select('*')
            .eq('fingerprint', fingerprint)
            .single();

        if (error) {
            if (status === 406) {
                throw new Error(`user fingerprint not found: ${fingerprint}`);
            }
            throw new Error(`Error getting user by fingerprint: ${error.message}`);
        }

        return data;
    }

    public static async saveLevels(levelsData: any) {
        const { data, error } = await this.supabase
            .from('levels')
            .upsert(levelsData)
            .select();

        if (error) {
            throw new Error(`Error saving levels: ${error.message}`);
        }

        return data;
    }

    public static async getLevelsByUser(userId: integer): Promise<any> {
        const { data, error, status } = await this.supabase
            .from('levels')
            .select('*')
            .eq('user_id', userId)
            .order('level', { ascending: true });

        if (error) {
            if (status === 406) {
                throw new Error(`user fingerprint not found: ${userId}`);
            }
            throw new Error(`Error getting user by fingerprint: ${error.message}`);
        }

        const levels = data.map(apiLevels => {
            return {
                id: apiLevels.level,
                score: apiLevels.score
            };
        });
        
        return levels;
    }
}